import React from "react";
import { Modal, Button } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

interface UnsavedChangesModalProps {
  open: boolean;
  onLeave: () => void;
  onCancel: () => void;
  message?: string;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  open,
  onLeave,
  onCancel,
  message,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      closable={false}
      width={500}
      styles={{
        body: {
          display: "flex",
          gap: 16,
          flexDirection: "column",
        },
      }}
    >
      <HeaderRow>
        <Title>{t("unsavedChangesModal.title")}</Title>
        <CloseButton onClick={onCancel}>✕</CloseButton>
      </HeaderRow>
      <Content>
        <p style={{ fontSize: 16, fontWeight: 400 }}>
          {message || t("unsavedChangesModal.defaultMessage")}
        </p>
        <ButtonRow>
          <StyledButton onClick={onLeave}>
            {t("unsavedChangesModal.leave")}
          </StyledButton>
          <StyledButton $primary onClick={onCancel} style={{ marginLeft: 8 }}>
            {t("unsavedChangesModal.cancel")}
          </StyledButton>
        </ButtonRow>
      </Content>
    </Modal>
  );
};

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 14px;
  color: #000;
  cursor: pointer;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StyledButton = styled(Button)<{ $primary?: boolean }>`
  background: ${({ $primary }) => ($primary ? "#f0f0f0" : "#fff")};
  color: ${({ $primary }) => ($primary ? "#000" : "#000")};
  border: ${({ $primary }) => ($primary ? "none" : "1px solid #d9d9d9")};
  border-radius: 6px;
  min-width: 80px;
  height: 36px;
  font-size: 16px;
  font-weight: 400;
  &:hover {
    background: ${({ $primary }) => ($primary ? "#f0f0f0" : "#fff")} !important;
    border: ${({ $primary }) =>
      $primary ? "none" : "1px solid #d9d9d9"} !important;
    color: #000 !important;
  }
`;

export default UnsavedChangesModal;
